import React from "react";
import {connect} from "react-redux";
import MybookList from "./MybookList";

const BooksList = (props) => {
    return(
        <div>
        {props.bookLists ?
            <div>
                <h1 className="content_title">Total {props.totalBooklists} Booklists</h1>
            <MybookList/> </div>: <div className="loader">
                        <div></div>
                        <h1>Please Wait...</h1>
                    </div>}

        </div>
    );
};

function mapStateToProps(state){
    return {totalBooklists: state.user.totalBooklists, bookLists: state.AllBooklists.bookLists}
}

export default connect(mapStateToProps, {})(BooksList);